import PropTypes from 'prop-types';
import get from 'lodash/get';
import { useState } from 'react';

import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import EditIcon from '@mui/icons-material/EditCalendar';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from "@mui/material/Typography";

import useUser from '../../hooks/useUser';
import NewSessionForm from '../sessions/NewSessionForm';
import SessionFormV2 from '../sessions/SessionFormV2';
import CustomDialog from '../common/CustomDialog';

const NewSessionButton = ({color = 'error', ...props}) => {
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const user = useUser();
  const isPatient = get(user, 'is_patient') || false;
  const {iconOnly, textOnly, session} = props;
  const childProps = {
    onClick: () => setDialogIsOpen(true),
    disabled: false,
    variant: iconOnly ? null : (props.variant || 'contained'),
    color: props?.color || iconOnly ? 'primary' : 'success',
    startIcon: iconOnly || textOnly ? null : <EditIcon/>,
    fullWidth: props.fullWidth || null,
    size: props.size,
  };
  const onClose = () => setDialogIsOpen(false);
  // Patients can no longer edit sessions
  if (isPatient) return null;
  const Form = (
    props.sessionVersion === '2'
    ? SessionFormV2
    : NewSessionForm
  );
  return (
    <>
      <CustomDialog
        open={dialogIsOpen}
        fullWidth={true}
        maxWidth='md'
        onClose={onClose}
        title='Schedule Session'
      >
        {
          props?.sessionType || props?.sessionVersion === '2'
          ? <Form
            sessionType={props?.sessionType}
            patient={props?.patient}
          />
          : null
        }
      </CustomDialog>
      {
        iconOnly
        ? <Tooltip title='Create Session'>
          <IconButton {...childProps}>
            <EditIcon/>
          </IconButton>
        </Tooltip>
        : <Button {...childProps} style={{marginTop: '1em'}}>
            {props?.buttonText || 'Override Session Type Settings'}
        </Button>
      }
    </>
  );
};

NewSessionButton.propTypes = {
  sessionType: PropTypes.object.isRequired,
  patient: PropTypes.object.isRequired,
  buttonText: PropTypes.string,
};

export default NewSessionButton;